<template>
  <div>
    <job-preview></job-preview>
  </div>
</template>
<script>
import JobPreview from '@/components/Job/Post/Forms/JobPreviewNew'
export default {
  components: { JobPreview }
}
</script>
